<template>
  <div>
    <ModuleHeader>Entradas/Salidas Manuales</ModuleHeader>
    <v-overlay v-if="loadingData">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col md="12" cols="12">
        <v-card elevation="0">
          <v-card-text>
            <v-row>
              <v-col md="2" cols="12">
                <v-menu
                  v-model="menuFechaInicial"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="input_date"
                      label="Fecha Inicial"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="input_date"
                    @input="menuFechaInicial = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="2">
                <v-menu
                  v-model="menuFechaInicial2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="input_date_final"
                      label="Fecha Final"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="input_date_final"
                    @input="menuFechaInicial2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="2" v-if="false">
                <v-autocomplete
                  v-model="input_categoria"
                  label="Categoría del producto"
                  :items="categoriesList"
                  item-value="id"
                  item-text="label"
                >
                </v-autocomplete>
              </v-col>
              <v-col md="2">
                <v-autocomplete
                  label="Almacen"
                  v-model="selectDep"
                  item-text="Nombre"
                  item-value="id"
                  :items="origenes"
                ></v-autocomplete>
              </v-col>
              <v-col class="text-right mt-n5" md="12">
                <v-btn
                  depressed
                  @click="cleanFilter()"
                  class="mx-2"
                  color="error"
                >
                  Restablecer Filtro
                </v-btn>
                <v-btn depressed @click="getDocuments()" color="success">
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12" cols="12">
        <v-card elevation="0">
          <v-card-text>
            <v-row>
              <v-col md="8"> Resultados </v-col>
              <v-col md="2" class="text-right"> </v-col>
              <v-col md="2" class="text-right">
                <v-btn color="green" dark @click="exportExcel"
                  ><v-icon>mdi-file-excel-box</v-icon>
                  Exportar a Excel
                  <!-- <download-excel
                    type="xls"
                    name="Reporte Entradas Salidas Manuales"
                    :data="datashow"
                  >
                  </download-excel> -->
                </v-btn>
              </v-col>
              <v-col md="12">
                <v-text-field v-model="filter" label="Filtrar"></v-text-field>
              </v-col>
            </v-row>
            <v-simple-table v-if="render" dense>
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Entradas Manuales</th>
                  <th>Salidas Manuales</th>
                  <th>Detalle</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="datashow.length == 0">
                  <td colspan="16">No se encontraron datos</td>
                </tr>
                <template v-for="(prod, index) in datashow">
                  <tr :key="index">
                    <td>
                      {{ prod.Id == "Reserva" ? "TEE TIMES" : prod.Nombre }}
                    </td>
                    <td>
                      <b>{{ prod.Entradas }}</b>
                    </td>
                    <td>
                      <b>{{ prod.Salidas }}</b>
                    </td>
                    <td>
                      <v-btn @click="showDetail(prod)" color="primary"
                        >Detalle</v-btn
                      >
                    </td>
                  </tr>
                </template>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <modal v-model="showModal" :showFooter="false" title="Detalle de producto">
      <div v-if="selectedProd">
        <h1>{{ selectedProd.Nombre }}</h1>
        <v-simple-table>
          <thead>
            <tr>
              <th>Movimiento</th>
              <th>Fecha</th>
              <th>Cantidad</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(mov, index) in selectedProd.Movs" :key="index">
              <td>{{ mov.Tipo }}</td>
              <td>{{ mov.FechaMovimiento }}</td>
              <td>{{ mov.Cantidad }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
    </modal>
  </div>
</template>

<style scoped></style>

<script>
import "../../assets/css/sideBar.css";
import Cliente from "../../clases/Cliente.js";
import moment from "moment";
import Currency from "../../clases/Currencies.js";
import Membresia from "../../clases/Membresias/Membresia.js";
import Vue from "vue";
import EntradasSalidasExcelExporter from "../../clases/ExcelMaker/ReporteEntradasSalidasExcel.js";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ReporteGeneral",
  components: {
    /*Select2,*/
  },
  props: ["hideMenu"],
  data() {
    return {
      selectDep: "ALL",
      menuFechaInicial: false,
      menuFechaInicial2: false,
      filter: "",
      loadingData: false,
      render: true,
      input_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      input_date_final: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      input_categoria: "ALL",
      Categories: [],
      Documentos: [],
      origenes: [],
      InOutProccessed: [],
      selectedProd: null,
      showModal: false,
    };
  },
  computed: {
    ...mapGetters("Categorias", ["getCategoriesFiltered"]),
    categoriesList() {
      let categories = [{ id: "ALL", label: "TODOS" }];

      this.Categories.forEach((categoria) => {
        categories.push(categoria);
      });
      return categories;
    },
    datashow() {
      if (this.filter != "") {
        return this.InOutProccessed.filter((acc) =>
          acc.Nombre.toUpperCase().includes(this.filter.toUpperCase())
        );
      }

      return this.InOutProccessed;
    },
    Membresias() {
      return this.$pgsHelper.indexBy(Membresia.getMembresiasList(), "Id");
    },
    selectedReserva() {
      return this.selectedRes;
    },
    departamentos() {
      let dep = [];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
  },
  methods: {
    exportExcel() {
      console.log(this.InOutProccessed);
      EntradasSalidasExcelExporter.exportReporteEntradasSalidas(
        this.InOutProccessed,
        "Reporte Entradas/Salidas Manuales",
        this.selectDep.Nombre
      )
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "ReporteEntradasSalidas.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => console.error("Error exportando Excel:", err));
    },
    showDetail(prod) {
      this.selectedProd = prod;
      this.showModal = true;
    },
    async getOrigenes() {
      var data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Inventario/Origenes"
      );

      if (!data.exists()) {
        return false;
      }
      let arrayOrg = Object.entries(data.val());
      let origenes = [];
      arrayOrg.forEach((element) => {
        if (!this.$route.params.idDocumento) {
          this.Origen = element[0];
        }
        //this.Origen =  element[0];
        origenes.push({
          id: element[0],
          Nombre: element[1]["Nombre"],
          Departamentos: element[1]["Departamentos"],
        });
      });

      this.origenes = origenes;
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      await this.fetchCategories();
      const claims = this.$route.params?.user?.tokenResult?.claims;
      this.Categories = this.getCategoriesFiltered(claims);
    },
    cleanFilter() {
      this.input_date = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.input_date_final = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.input_folio = "";
      this.selectClient = "";
      this.selectDep = "ALL";
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getDocuments() {
      this.Documentos = [];
      const startDate = this.input_date;
      const endDate = this.input_date_final;
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      var data = await firestore.queryBuilder("PDV_Prod_EntSal", [
        firestore.where("Origen", "==", this.selectDep),
        firestore.where("FechaMovimiento", ">=", startDate),
        firestore.where("FechaMovimiento", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);

      //this.$pgsHelper.log(data.docs.map(doc=>{return {id:doc.ref.id,...doc.data()}}));
      let document = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      document.forEach((data) => {
        /* let dateFormat = new firestore.Timestamp(
          data.FechaCreacion.seconds,
          data.FechaCreacion.nanoseconds
        );*/

        //let origenData = this.getOrigenById(data.Origen);
        if (data.Aplicado) {
          this.Documentos.push(data);
        }
      });

      this.Documentos = this.$_.orderBy(this.Documentos, "Fecha", "desc");
      this.processDataAlmacen();
    },
    async processDataAlmacen() {
      let productos = [];
      this.Documentos.forEach((doc) => {
        doc.Productos.forEach((prod) => {
          let exist = this.$pgsHelper.getById(productos, "Id", prod.Id);
          if (!exist) {
            productos.push({
              Id: prod.Id,
              Nombre: prod.Nombre,
              Entradas: 0,
              Salidas: 0,
              Movs: [],
            });
          }
          let prodFind = this.$pgsHelper.getById(productos, "Id", prod.Id);
          let index = prodFind.idx;
          if (doc.TipoMovimiento == "Entrada") {
            productos[index].Movs.push({
              Tipo: "Entrada",
              FechaMovimiento: doc.FechaMovimiento,
              Cantidad: prod.Cantidad,
            });
            productos[index].Entradas += prod.Cantidad;
          } else {
            productos[index].Movs.push({
              Tipo: "Salida",
              FechaMovimiento: doc.FechaMovimiento,
              Cantidad: prod.Cantidad,
            });
            productos[index].Salidas += prod.Cantidad;
          }
        });
      });
      console.log(productos);
      this.InOutProccessed = productos;
    },
  },
  beforeCreate: function () {},
  beforeMount: function () {
    this.getOrigenes();
    this.getCategories();
  },
};
</script>

<style>
.input input {
  border-bottom: 1px solid black;
  width: 100%;
}
</style>
